// 切工
export function cutFilter(cut) {
  var gia
  if (cut == 'Y') {
    gia = '是'
    return gia
  } else if (cut == 'N') {
    gia = '否'
    return gia
  }
}
// 网点状态
export function dotState(dot) {
  var dot
  if (dot == 'O') {
    dot = '运营中'
    return dot
  } else if (dot == 'S') {
    dot = '网点已停运，请重新选择网点。'
    return dot
  } else if (dot == 'F') {
    dot = '网点已冻结，请重新选择网点。'
    return dot
  } else if (dot == 'T') {
    dot = '试运行'
    return dot
  }
}
// 订单类型
export function orderTypeFilter(type) {
  const orderType = {
    '10': '待支付',
    '20': '已支付',
    '40': '已送检',
    '50': '已发货',
    // '60': '已作废',
    '70': '已取消',
    '80': '已完成',
  }[type]
  return orderType || ''
}
